export default {
  install(Vue, store) {
    Vue.prototype.$loading = {
      show() {
        store.commit('app/TOGGLE_OVERLAY', true)
      },
      hide() {
        store.commit('app/TOGGLE_OVERLAY', false)
      },
    }
  },
}
